import { SpecialAttackSkill, StatusSkill, PhysicalAttackSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

export const 千雪折樱 = new SpecialAttackSkill(
    "千雪折樱",
    type.冰,
    [
        "消除对手的能力提升，消除成功则随机使对手2个技能pp归零",
        "消除对手的回合类效果，消除成功则免疫下1回合受到的攻击",
        "命中后100%令对手冻伤",
    ],
    80,
    [
        new Effect(new effect.消除强化(), Timing.onDamage),
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new RoundEffect(
                Timing.triggered,
                1,
                new effect.免疫攻击(),
                Timing.beforeSkillHit,
                undefined,
                false,
                [],
            ).nextRound(),
        ]),
        new Effect(new effect.施加异常状态(new state.冻伤()), Timing.onDamage),
    ],
    3,
);

export const 雪舞冰封 = new StatusSkill(
    "雪舞冰封",
    [
        "4回合内，每回合吸取对手最大体力的1/3",
        "4回合内，每回合恢复自身最大体力的1/3",
        "命中后有80%的几率令对手冰封，未触发则消除对手的回合类效果，消除成功则对手全属性-1",
    ],
    [],
);

export const 圣灵闪 = new PhysicalAttackSkill(
    "圣灵闪",
    type.圣灵,
    [
        "若打出致命一击则恢复自身最大体力的1/1",
        "免疫下2次异常状态",
        "附加对手防御、特防值总和60%的固定伤害",
    ],
    120,
    [
        new Effect(
            new effect.恢复体力(pred.自身最大体力的x分之一(1)),
            Timing.onDamage,
            cond.若打出致命一击,
        ),
        new Effect(new effect.固伤(pred.对手防御特防总和的百分之x(60)), Timing.onDamage),
    ],
    2,
    undefined,
    10,
);

export const 冰封王座 = new StatusSkill(
    "冰封王座",
    [
        "全属性+1，对手不处于能力下降状态时强化效果翻倍",
        "3回合内，每回合自身特攻、速度+1",
        "下2回合造成的伤害提升150%",
        "下2回合所有技能先制+2",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若对手不处于弱化状态),
            Timing.onSkillHit,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.增伤(150),
            Timing.beforeDamage,
            undefined,
            false,
            [],
        ).nextRound(),
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.属性提升({ mAtk: 1, speed: 1 }),
            Timing.actionEnd,
            undefined,
            false,
            [],
        ),
    ],
);

/** 极冰风暴：冰封施加失败时通过未触发谓词改为施加冻伤。 */
export const 极冰风暴 = new SpecialAttackSkill(
    "极冰风暴",
    type.冰,
    [
        "无视克制关系，克制倍数最低视为1倍",
        "无视对手免疫伤害效果",
        "命中后有50%的几率令对手冰封，未触发则100%令对手冻伤",
        "对手处于异常状态时技能威力翻倍",
        "若对手不处于异常状态，则吸取对手最大体力的1/3",
    ],
    150,
    [
        new Effect(
            new effect.威力提升(100),
            Timing.beforeDamage,
            cond.若对手处于异常状态,
        ),
        new Effect(
            new effect.施加异常状态(new state.冰封()),
            Timing.onDamage,
            cond.百分之x的几率(50),
            [new Effect(new effect.施加异常状态(new state.冻伤()), Timing.untriggered)],
        ),
        new Effect(
            new effect.吸取体力(({ sbjPet }) => Math.round(sbjPet.最大体力 * (1 / 3))),
            Timing.onDamage,
            cond.若对手不处于异常状态,
        ),
    ],
    undefined,
    true,
);

export const 极度冰点 = new SpecialAttackSkill(
    "极度冰点",
    type.冰,
    [
        "命中后有50%几率秒杀对手",
        "未命中对手则牺牲自己，然后使己方的出战精灵前3回合内，免疫异常状态、免疫能力下降、所有技能先制+1、造成的伤害随机提升50%~150%",
    ],
    160,
    [
        new Effect(
            new effect.秒杀(),
            Timing.onDamage,
            cond.百分之x的几率(50),
        )
    ],
    2,
    false,
    undefined,
    1,
);
